export const PersonalDataForm = {
	organisation: {
		required: true,
	},
};
